import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { TokenService } from './token.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private loggedIn = new BehaviorSubject<boolean>(this.token.loggedIn());

  authStatus = this.loggedIn.asObservable();

  changeStatus(value: boolean){
    this.loggedIn.next(value);
  }

  constructor(private token: TokenService, private router: Router) { }

  logout() {
    this.token.remove();
    localStorage.clear();
    this.changeStatus(false);
    this.router.navigateByUrl('/login');
  }

  checkDoubleExtension(filename) {
    // console.log(filename);
    var ext = filename.match(/\.(.+)$/)[1];
    if (ext.indexOf('.') !== -1) {
      return 0;
    }
    return 1;
  }

}
